import { createPortal } from "react-dom"
import { Popup, useMap } from "react-leaflet"
import { useSelector, useDispatch } from "react-redux"
import { useMemo, useState, useRef } from "react"
import { $authHost } from "../../http"
import React from "react"
import { formarDate, statuses, translate } from "../controls/old/AccountingSheetTableControl";
import { useAuth } from "react-oidc-context"
import {
    Typography,
    Box,
    Tabs,
    Tab,
    Button,
    Card,
    CardContent,
    Chip,
    Divider,
    Paper,
    IconButton,
    Stack
} from "@mui/material";
import {
    Timeline as TimelineIcon,
    Build as BuildIcon,
    Description as DescriptionIcon,
    Place as PlaceIcon,
    Person as PersonIcon,
    DateRange as DateIcon,
    Speed as SpeedIcon,
    Cable as CableIcon,
    Straighten as RulerIcon,
    Numbers as NumbersIcon,
    Info as InfoIcon,
    ExpandMore as ExpandMoreIcon,
    ExpandLess as ExpandLessIcon,
    CheckCircle as CheckCircleIcon,
    Cancel as CancelIcon,
    Share as ShareIcon
} from "@mui/icons-material";
import Viewer from "react-viewer";
import { setModal, setLayers } from "../../store/reducers/helpersReducer"
import L from "leaflet"
import { colorMap } from "../layers/helper"
import { useEffect } from "react";
import { Fragment } from "react";
import { addPulseMarker } from "../controls/helpers"
import { selectTasksByObject } from "../../store/selectors/tasksSelector"
import TaskTab from "./Common/TaskTab"
import RelatedObjectsPanel from "./Common/RelatedObjectsPanel"



const TabPanel = ({ children, value, index }) => {
    return value === index && <Box>{children}</Box>;
};

const colors = { 'П': [147, 51, 234], 'Г': [16, 185, 129], 'С': [59, 130, 246], 'Р': [246, 34, 58] };
const types = {
    'pillar04': 'Опора 0,4кВ',
    'pillar10': 'Опора 10кВ',
    'pillar04_10': 'Опора 0,4-10кВ',
}
const PopupFider = ({ mark, latlng }) => {
    console.log(mark)
    const map = useMap()
    const dispatch = useDispatch()
    const auth = useAuth()
    const [value, setValue] = useState(null);
    const valueRef = useRef(null);

    const [spec, setSpec] = useState({})
    const [segment, setSegment] = useState(null)
    const [mountHistory, setMountHistory] = useState([])

    const [expandSpec, setExpandedSpec] = useState([])
    const [expandedMountItems, setExpandedMountItems] = useState([])

    const specs = useSelector(state => state.state.specs)
    const usersSettings = useSelector(state => state.state.usersSettings)
    const pillars = useSelector(state => state.state.electricity.pillars)
    const transformers = useSelector(state => state.state.electricity.transformers)
    // const [mounted, setMounted] = useState(null)

    // Формируем ID фидера в формате задачи: {fider.id}_{object1.type}_{object1.id}_{object2.type}_{object2.id}
    const getFiderTaskId = useMemo(() => {
        if (typeof segment !== "number" || !mark.connected || segment >= mark.connected.length - 1) {
            return null;
        }
        const object1 = mark.connected[segment];
        const object2 = mark.connected[segment + 1];
        if (!object1 || !object2) return null;
        const fiderId = mark.id || mark.fid;
        return `${fiderId}_${object1.type}_${object1.id}_${object2.type}_${object2.id}`;
    }, [mark, segment]);

    // Получаем задачу для фидера (для проверки наличия и автоматического открытия вкладки)
    const objectType = 'fiders';
    const task = useSelector(state => {
        if (!getFiderTaskId) return undefined;
        return selectTasksByObject(state, objectType, getFiderTaskId);
    });

    // const mountedFiders = useMemo(() => {
    //     if (!mounted.fiders) return null
    //     return mounted.filter(f => f.fid === mark.id)
    // }, [mounted])
    // const { mounted } = useSelector(state => state.helpers)


    useEffect(() => {
        if (specs && mark.spec) {
            setSpec(prev => ({
                ...prev,
                name: specs.fiders.find(s => s.id === mark.spec)?.name,
                specs: mark.specs?.map(spec => specs.fiders.find(s => s.id === spec)?.name) || null
            }))
        }
    }, [specs, mark])

    useEffect(() => {
        if (typeof segment !== "number" || !mark.connected || segment >= mark.connected.length - 1) {
            setMountHistory([]);
            return;
        }

        // Получаем историю изменений для фидера
        $authHost.get(`/apig/execution/fiders/${mark.id}/history`).then(res => {
            const key = `${mark.connected[segment].type}_${mark.connected[segment].id}_${mark.connected[segment + 1].type}_${mark.connected[segment + 1].id}`;
            const history = res.data?.data || [];

            // Фильтруем историю по сегменту и формируем массив записей с данными сегмента
            const segmentHistoryMap = new Map();
            history
                .filter(item => item.state?.segments?.[key])
                .map(item => item.state.segments[key])
                .forEach(segment => {
                    const date = segment.date || segment.created_at;
                    if (date) {
                        // Если запись с такой датой уже есть, заменяем её (оставляем последнюю)
                        segmentHistoryMap.set(date, segment);
                    }
                });
            
            const segmentHistory = Array.from(segmentHistoryMap.values())
                .sort((a, b) => new Date(b.created_at || b.date) - new Date(a.created_at || a.date));

            setMountHistory(segmentHistory);
        }).catch(err => {
            console.log(`Get mount history for fider ${mark.fid} error`, err);
            setMountHistory([]);
        });
    }, [mark, segment])

    useEffect(() => {
        let segm = null
        mark.coordinates.map((coords, i) => {
            if (i === mark.coordinates.length - 1) return null
            const sw = [Math.min(mark.coordinates[i][0], mark.coordinates[i + 1][0]), Math.min(mark.coordinates[i][1], mark.coordinates[i + 1][1])]
            const ne = [Math.max(mark.coordinates[i][0], mark.coordinates[i + 1][0]), Math.max(mark.coordinates[i][1], mark.coordinates[i + 1][1])]

            const bounds = new L.latLngBounds(sw, ne)
            if (bounds.contains(latlng)) segm = i
        })
        setSegment(segm)
    }, [mark, latlng])

    // Инициализируем значение таба после загрузки данных
    useEffect(() => {
        // Получаем доступные табы
        const availableTabs = [];
        availableTabs.push(1); // Спецификация всегда доступна
        if (mountHistory && mountHistory.length > 0) {
            availableTabs.push(2); // Монтаж (если есть история для сегмента)
        }
        if (task) {
            availableTabs.push(3); // Задача
        }
        availableTabs.push(4); // Связанные объекты всегда доступна

        if (availableTabs.length === 0) return;

        // Если значение еще не установлено, проверяем задачу
        if (value === null) {
            // Если задача не завершена, открываем вкладку "Задача" первой
            if (task && availableTabs.includes(3)) {
                const taskStatus = task.statusCurrent || task.status;
                if (taskStatus !== 'done' && taskStatus !== 'cancelled') {
                    setValue(3);
                    valueRef.current = 3;
                    return;
                }
            }

            // Иначе устанавливаем первый доступный таб
            setValue(availableTabs[0]);
            valueRef.current = availableTabs[0];
            return;
        }

        // Проверяем, доступен ли текущий таб
        const isCurrentTabAvailable = availableTabs.includes(value);

        // Если текущий таб недоступен, устанавливаем первый доступный
        if (!isCurrentTabAvailable) {
            setValue(availableTabs[0]);
            valueRef.current = availableTabs[0];
        }
    }, [mountHistory, task, value]);

    useEffect(() => {
        if (typeof (segment) !== "number" || !mark.connected) return
        let objects = mark.connected.slice(segment, segment + 2)
        console.log(objects)
        if (!objects[0] || !objects[1]) return
        let objectsR = objects.map(o => o.type === 'pillar' ? pillars.find(p => p.fid === o.id) : transformers.find(t => t.fid === o.id))
        // const object1 = objects[0].type === 'pillar' ? pillars.find(p => p.fid === objects[0].id) : transformers.find(t => t.fid === objects[0].id)
        // const object2 = objects[1].type === 'pillar' ? pillars.find(p => p.fid === objects[1].id) : transformers.find(t => t.fid === objects[1].id)

        if (objectsR.length === 2) {
            const objectsChains = objectsR.map(o => o.type.includes('pillar') ? specs.pillars.find(s => s.id === o.spec)?.chains : Infinity)

            const chains = Math.min(...objectsChains)
            // const object1Spec = objects[0].type === 'pillar' ? specs.pillars.find(s => s.id === object1.spec)
            // const object1Chains = objects[0].type === 'pillar' ? object1.mounted.chains : Infinity
            // const object2Chains = objects[1].type === 'pillar' ? object2.mounted.chains : Infinity
            // // Определение количества цепей
            // let quantity = Math.min(object1Chains, object2Chains)

            // const distance = objectsR[0]?.connected?.find(c => c.id === objectsR[1].fid)?.distance || objectsR[1]?.connected?.find(c => c.id === objectsR[0].fid)?.distance || 0
            const from = new L.LatLng(mark.coordinates[segment][0], mark.coordinates[segment][1]);
            const to = new L.LatLng(mark.coordinates[segment + 1][0], mark.coordinates[segment + 1][1]);
            const distance = from.distanceTo(to).toFixed(2);
            const between = objectsR.map(o => o.name).join(' - ')
            const betweenKey = objectsR.map(o => `${o.type}_${o.id}`).join('_')
            setSpec(prev => ({ ...prev, objects: objectsR, chains, distance, between, betweenKey }))

        }
        if (mark.sip_class?.length > 0) {
            setSpec(prev => ({ ...prev, chains: mark.sip_class.reduce((t, r) => t + Number(r.qty_chains), 0) }))
        }
    }, [segment, mark])

    // useEffect(() => {
    //     if (!spec.objects || !mounted) return

    //     setMount(mounted.filter(m => m.object_1_fid === spec.objects[0].fid && m.object_2_fid === spec.objects[1].fid).sort((a, b) => (
    //         new Date(b.created_at) - new Date(a.created_at)
    //     )))
    // }, [mark, spec, mounted])



    function getExpandSpec(spec, margin = 0) {
        if (!spec.complect || spec.complect.length === 0 || !expandSpec || !expandSpec.includes(spec.id)) return null
        return spec.complect.map((c, y) => {
            let mass = (parseFloat(c.massa_1ed_kg) * parseFloat(c.count)).toString()
            mass = mass.includes('.') ? mass.split('.') : [mass]
            if (mass.length > 1) {
                mass[1] = mass[1].slice(0, 4)
            }
            return (<Fragment key={`fragment_${spec.id}_${c.id || y}`}>
                <tr key={`${spec.id}_${c.id || y}`}>
                    <td style={{ paddingLeft: `${margin}px`, cursor: 'pointer' }} onClick={(event) => {
                        event.stopPropagation();
                        if (c.complect) {
                            setExpandedSpec(prev => prev.includes(c.id) ? prev.filter(id => id !== c.id) : [...prev, c.id])
                        }
                    }}><b>{c.complect ? expandSpec.includes(c.id) ? '− ' : '+ ' : ''}</b>{c.name}</td>
                    <td>{c.type_marka_docs}</td>
                    <td>{c.factory_manufacturer}</td>
                    <td style={{ textAlign: 'center' }}>{parseFloat(c.count).toString().replace('.', ',')} {c.unit}</td>
                    <td style={{ textAlign: 'center' }}>{mass.join(',')}</td>
                </tr>
                {getExpandSpec(c, margin + 10)}
            </Fragment>
            )
        })
    }



    function formatDate(dateString) {
        const date = new Date(dateString);
        return date.toLocaleString('ru-RU', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit'
        });
    }

    function getMountHistory() {
        if (!mountHistory || mountHistory.length === 0) {
            return (
                <Paper elevation={0} sx={{ p: 2, textAlign: 'center', bgcolor: 'grey.50', fontSize: { xs: '0.7rem', sm: '0.8rem' } }}>
                    <BuildIcon sx={{ fontSize: 32, color: 'grey.400', mb: 1 }} />
                    <Typography variant="body2" color="text.secondary" sx={{ fontSize: { xs: '0.7rem', sm: '0.8rem' } }}>
                        Данные о монтаже отсутствуют
                    </Typography>
                </Paper>
            );
        }

        // Вычисляем расчетную длину один раз
        const originalLength = spec.distance ? parseFloat(spec.distance) : 0;
        
        return mountHistory.map((mount, index) => {
            const isExpanded = expandedMountItems.includes(index);
            const isCompleted = mount.status === 1;
            const isSipChanged = JSON.stringify(mark.sip_class.map(s => s.id)) !== JSON.stringify(mount.sip_class)
            // Вычисляем прогресс на основе длины (если есть исходная длина)
            const mountedLength = mount.length || 0;
            const progress = originalLength > 0
                ? Math.round((mountedLength / originalLength) * 100)
                : (mount.progress ? Math.round(mount.progress * 100) : 100);

            // Находим пользователя по userid (приоритет user_id из записи, затем userid из сегмента)
            const userId = mount.user_id || mount.userid;
            const user = usersSettings?.find(u => u.id === userId);
            const userName = mount.user_name || (user?.name || `ID: ${userId}`);

            // Форматируем дату (приоритет created_at из записи, затем date из сегмента)
            const dateValue = mount.created_at || mount.date;
            const mountDate = dateValue
                ? (() => {
                    const date = typeof dateValue === 'number' ? new Date(dateValue) : new Date(dateValue);
                    const hours = String(date.getHours()).padStart(2, '0');
                    const minutes = String(date.getMinutes()).padStart(2, '0');
                    const day = String(date.getDate()).padStart(2, '0');
                    const month = String(date.getMonth() + 1).padStart(2, '0');
                    const year = date.getFullYear();
                    return `${hours}:${minutes} ${day}.${month}.${year}`;
                })()
                : 'Не указано';

            return (
                <Card key={`mount_item_${index}`} variant="outlined" sx={{ mb: 0.5, fontSize: { xs: '0.7rem', sm: '0.8rem' } }}>
                    <CardContent
                        onClick={(event) => {
                            event.stopPropagation();
                            setExpandedMountItems(prev =>
                                prev.includes(index) ? prev.filter(i => i !== index) : [...prev, index]
                            );
                        }}
                        sx={{
                            p: { xs: 0.5, sm: 0.5 },
                            cursor: 'pointer',
                            '&:hover': { bgcolor: 'action.hover' },
                            '&:last-child': { pb: { xs: 0.5, sm: 0.5 } }
                        }}
                    >
                        <Stack direction="row" alignItems="center" spacing={1} whiteSpace="wrap">
                            <IconButton size="small" sx={{ p: 0 }}>
                                {isExpanded ? <ExpandLessIcon fontSize="small" sx={{ fontSize: { xs: '0.7rem', sm: '0.8rem' } }} /> : <ExpandMoreIcon fontSize="small" sx={{ fontSize: { xs: '0.7rem', sm: '0.8rem' } }} />}
                            </IconButton>

                            <Chip
                                icon={isCompleted ? <CheckCircleIcon sx={{ fontSize: { xs: '0.6rem', sm: '0.8rem' } }} /> : <CancelIcon sx={{ fontSize: { xs: '0.6rem', sm: '0.8rem' } }} />}
                                label={isCompleted ? 'Выполнено' : 'Не выполнено'}
                                color={isCompleted ? 'success' : 'error'}
                                size="small"
                                sx={{ fontSize: { xs: '0.6rem', sm: '0.8rem' } }}
                                onClick={(event) => {
                                    event.stopPropagation();
                                    setExpandedMountItems(prev =>
                                        prev.includes(index) ? prev.filter(i => i !== index) : [...prev, index]
                                    );
                                }}
                            />

                            {isSipChanged && (
                                <Chip
                                    label={"СИП изменен"}
                                    color={"secondary"}
                                    size="small"
                                    sx={{ fontSize: { xs: '0.6rem', sm: '0.8rem' } }}
                                    onClick={(event) => {
                                        event.stopPropagation();
                                        setExpandedMountItems(prev =>
                                            prev.includes(index) ? prev.filter(i => i !== index) : [...prev, index]
                                        );
                                    }}
                                />
                            )}

                            <Chip
                                icon={<SpeedIcon sx={{ fontSize: { xs: '0.6rem', sm: '0.8rem' } }} />}
                                label={`${progress}%`}
                                variant="outlined"
                                size="small"
                                color={progress > 102 ? 'error' : progress < 98 ? 'warning' : 'success'}
                                sx={{ fontSize: { xs: '0.6rem', sm: '0.8rem' } }}
                                onClick={(event) => {
                                    event.stopPropagation();
                                    setExpandedMountItems(prev =>
                                        prev.includes(index) ? prev.filter(i => i !== index) : [...prev, index]
                                    );
                                }}
                            />

                            <Chip
                                label={mountDate}
                                color={'primary'}
                                size="small"
                                sx={{ fontSize: { xs: '0.6rem', sm: '0.8rem' } }}
                                onClick={(event) => {
                                    event.stopPropagation();
                                    setExpandedMountItems(prev =>
                                        prev.includes(index) ? prev.filter(i => i !== index) : [...prev, index]
                                    );
                                }}
                            />

                            <Chip
                                label={userName}
                                color={'warning'}
                                size="small"
                                sx={{ fontSize: { xs: '0.6rem', sm: '0.8rem' } }}
                                onClick={(event) => {
                                    event.stopPropagation();
                                    setExpandedMountItems(prev =>
                                        prev.includes(index) ? prev.filter(i => i !== index) : [...prev, index]
                                    );
                                }}
                            />
                        </Stack>
                    </CardContent>

                    {isExpanded && (
                        <>
                            <Divider />
                            <CardContent sx={{ p: 1.5, pt: 1, '&:last-child': { pb: 1 }, fontSize: { xs: '0.7rem', sm: '0.8rem' } }}>
                                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5, mb: 1.5 }}>
                                    <Box sx={{ flex: 1 }}>
                                        <Stack spacing={0.5}>
                                            <Stack direction="row" alignItems="center" spacing={0.5}>
                                                <CableIcon sx={{ fontSize: 16, color: 'success.main' }} />
                                                <Typography variant="body2" fontWeight="600" color="text.primary" sx={{ fontSize: { xs: '0.8rem', sm: '0.9rem' } }}>
                                                    Класс СИП
                                                </Typography>
                                            </Stack>
                                            {mount.sip_class && mount.sip_class.length > 0 ? (
                                                <Stack spacing={0.25} sx={{ pl: 0.5 }}>
                                                    {mount.sip_class.map((sipClassId, sipIndex) => {
                                                        console.log(mark)
                                                        const isChanged = mark.sip_class[sipIndex].id !== sipClassId
                                                        const sipClass = specs?.sip_class?.find(s => s.id === sipClassId);
                                                        return (
                                                            <Typography key={`sip-${index}-${sipIndex}`} variant="caption" color="text.primary" fontWeight="500" sx={{ fontSize: { xs: '0.7rem', sm: '0.8rem' } }}>
                                                                • {sipClass?.name_str || `ID: ${sipClassId}`}{isChanged ? <b>{` (тип изменен с: ${specs?.sip_class?.find(s => s.id === mark.sip_class[sipIndex]?.id)?.name_str})`}</b> : ''}
                                                            </Typography>
                                                        );
                                                    })}
                                                </Stack>
                                            ) : (
                                                <Typography variant="caption" color="text.secondary" sx={{ fontSize: { xs: '0.7rem', sm: '0.8rem' } }}>
                                                    Не указано
                                                </Typography>
                                            )}
                                        </Stack>
                                    </Box>
                                    <Box sx={{ flex: 1 }}>
                                        <Stack spacing={0.5}>
                                            <Stack direction="row" alignItems="center" spacing={0.5}>
                                                <RulerIcon sx={{ fontSize: 16, color: 'warning.main' }} />
                                                <Typography variant="body2" fontWeight="600" color="text.primary" sx={{ fontSize: { xs: '0.8rem', sm: '0.9rem' } }}>
                                                    Расстояние
                                                </Typography>
                                            </Stack>
                                            <Typography variant="caption" color="text.primary" fontWeight="500" sx={{ fontSize: { xs: '0.7rem', sm: '0.8rem' } }}>
                                                Расчетное: <strong>{originalLength.toFixed(2)} м</strong>
                                            </Typography>
                                            <Typography variant="caption" color="text.primary" fontWeight="500" sx={{ fontSize: { xs: '0.7rem', sm: '0.8rem' } }}>
                                                Смонтировано: <strong>{mountedLength.toFixed(2)} м</strong>
                                            </Typography>
                                        </Stack>
                                    </Box>

                                </Box>
                            </CardContent>
                        </>
                    )}
                </Card>
            );
        });
    }

    function getTabs() {
        return (
            <Paper elevation={0} sx={{ bgcolor: 'background.paper' }}>
                <Tabs
                    value={value}
                    onChange={(_event, newValue) => setValue(newValue)}
                    textColor="primary"
                    indicatorColor="primary"
                    variant="fullWidth"
                    sx={{
                        minHeight: { xs: 24, sm: 32 },
                        '& .MuiTab-root': {
                            minHeight: { xs: 24, sm: 32 },
                            py: { xs: 0.2, sm: 0.5 },
                            fontSize: { xs: '0.6rem', sm: '0.7rem' },
                            fontWeight: 600
                        }
                    }}
                >
                    <Tab
                        value={1}
                        label="Спецификация"
                        icon={<DescriptionIcon fontSize="small" />}
                        iconPosition="start"
                        sx={{ gap: 0.5 }}
                    />
                    {mountHistory && mountHistory.length > 0 && (
                        <Tab
                            value={2}
                            label="Монтаж"
                            icon={<TimelineIcon fontSize="small" />}
                            iconPosition="start"
                            sx={{ gap: 0.5 }}
                        />
                    )}
                    {task && (
                        <Tab
                            value={3}
                            label="Задача"
                            icon={<TimelineIcon fontSize="small" />}
                            iconPosition="start"
                            sx={{ gap: 0.5 }}
                        />
                    )}
                    <Tab
                        value={4}
                        label="Связанные объекты"
                        icon={<ShareIcon fontSize="small" />}
                        iconPosition="start"
                        sx={{ gap: 0.5, lineHeight: 1.1 }}
                    />
                </Tabs>

                <TabPanel value={value} index={1}>
                    <Card variant="outlined" sx={{ m: 0 }}>
                        <CardContent sx={{ p: 1, '&:last-child': { pb: 1 } }}>
                            <Stack spacing={0.5}>
                                {/* <Stack direction="row" alignItems="center" spacing={0.5}>
                                    <DescriptionIcon sx={{ fontSize: 18, color: 'primary.main' }} />
                                    <Typography variant="subtitle2" fontWeight="600" color="text.primary" sx={{ fontSize: { xs: '0.7rem', sm: '0.8rem' } }}>
                                        {spec.name || 'Спецификация не указана'}
                                    </Typography>
                                </Stack>

                                <Divider /> */}

                                <Stack spacing={0.5}>
                                    <Box>
                                        <Stack direction="row" alignItems="center" spacing={0.5}>
                                            <PlaceIcon sx={{ fontSize: 16, color: 'primary.main' }} />
                                            <Typography variant="body2" fontWeight="500" color="text.primary" sx={{ fontSize: { xs: '0.7rem', sm: '0.8rem' } }}>
                                                Пролет между:
                                            </Typography>
                                        </Stack>
                                        <Typography variant="body2" color="text.primary" fontWeight="600" sx={{ pl: 0.5, m: '3px !important', fontSize: { xs: '0.7rem', sm: '0.8rem' } }}>
                                            {spec.between || 'Не указано'}
                                        </Typography>
                                    </Box>
                                    <Box sx={{ flex: 1 }}>
                                        <Stack direction="row" alignItems="center" spacing={0.5}>
                                            <NumbersIcon sx={{ fontSize: 16, color: 'info.main' }} />
                                            <Typography variant="body2" fontWeight="500" color="text.primary" sx={{ fontSize: { xs: '0.7rem', sm: '0.8rem' } }}>
                                                Тип провода - количество цепей:
                                            </Typography>
                                        </Stack>
                                        {spec.specs?.length > 0 ?
                                            (spec.specs.map((s, i) => (
                                                <Typography variant="body2" color="text.primary" fontWeight="600" sx={{ pl: 0.5, m: '3px !important', fontSize: { xs: '0.7rem', sm: '0.8rem' } }}>
                                                    {s || 'Спецификация не указана'} - {mark.sip_class[i].qty_chains || 0}
                                                </Typography>
                                            )))
                                            :
                                            <Typography variant="body2" color="text.primary" fontWeight="600" sx={{ pl: 0.5, m: '3px !important', fontSize: { xs: '0.7rem', sm: '0.8rem' } }}>
                                                {spec.name || 'Спецификация не указана'} - {spec.chains || 0}
                                            </Typography>
                                        }

                                    </Box>

                                    <Box sx={{ display: 'flex', gap: 0.5 }}>
                                        <Box sx={{ flex: 1 }}>
                                            <Stack direction="row" alignItems="center" spacing={0.5}>
                                                <RulerIcon sx={{ fontSize: 16, color: 'success.main' }} />
                                                <Typography variant="body2" fontWeight="500" color="text.primary" sx={{ fontSize: { xs: '0.7rem', sm: '0.8rem' } }}>
                                                    Расстояние:
                                                </Typography>
                                            </Stack>
                                            <Typography variant="body2" color="text.primary" fontWeight="600" sx={{ pl: 0.5, m: '3px !important', fontSize: { xs: '0.7rem', sm: '0.8rem' } }}>
                                                {spec.distance || 0} м
                                            </Typography>
                                        </Box>
                                        <Box sx={{ flex: 1 }}>
                                            <Stack direction="row" alignItems="center" spacing={0.5}>
                                                <NumbersIcon sx={{ fontSize: 16, color: 'info.main' }} />
                                                <Typography variant="body2" fontWeight="500" color="text.primary" sx={{ fontSize: { xs: '0.7rem', sm: '0.8rem' } }}>
                                                    Количество цепей:
                                                </Typography>
                                            </Stack>

                                            <Typography variant="body2" color="text.primary" fontWeight="600" sx={{ pl: 0.5, m: '3px !important', fontSize: { xs: '0.7rem', sm: '0.8rem' } }}>
                                                {spec.chains || 0}
                                            </Typography>

                                        </Box>

                                    </Box>

                                </Stack>
                            </Stack>
                        </CardContent>
                    </Card>
                </TabPanel>

                <TabPanel value={value} index={2}>
                    <Box sx={{ maxHeight: '320px', overflowY: 'auto', scrollbarWidth: 'thin', pt: 0.5 }}>
                        {getMountHistory()}
                    </Box>
                </TabPanel>

                <TabPanel value={value} index={3}>
                    <TaskTab
                        mark={{
                            ...mark,
                            segment: segment,
                            connected: mark.connected
                        }}
                        darkMode={false}
                        map={map}
                    />
                </TabPanel>

                <TabPanel value={value} index={4}>
                    <RelatedObjectsPanel mark={mark} darkMode={false} />
                </TabPanel>
            </Paper>
        );
    }
    return (
        createPortal(
            <Popup
                position={latlng}
                key={`fider_${mark.fid}`}
                maxWidth={window.innerWidth < 768 ? 350 : 600}
                autoClose={false}
                offset={[0, 10]}
                className="fider-popup"
            >
                <Paper elevation={0} sx={{ m: 0, p: 0, bgcolor: 'transparent' }}>
                    {/* Заголовок */}
                    <Card variant="outlined" sx={{ mb: { xs: 0.5, sm: 1 } }}>
                        <CardContent sx={{ p: 0.5, textAlign: 'center', '&:last-child': { pb: 0.5 } }}>
                            <Stack direction="row" alignItems="center" justifyContent="center" spacing={1}>
                                <CableIcon sx={{ fontSize: 20, color: 'primary.main' }} />
                                <Typography variant="subtitle1" fontWeight="600" color="primary.main" sx={{ fontSize: { xs: '0.8rem', sm: '1rem' } }}>
                                    {mark.layer}
                                </Typography>
                            </Stack>
                        </CardContent>
                    </Card>

                    {/* Основной контент */}
                    <Box sx={{ mb: 1 }}>
                        {getTabs()}
                    </Box>

                    {/* Кнопки действий */}
                    <Stack direction="row" spacing={1} justifyContent="flex-start">
                        {latlng && (
                            <Button
                                variant="outlined"
                                size="small"
                                startIcon={<PlaceIcon sx={{ fontSize: { xs: '0.7rem', sm: '0.75rem' } }} />}
                                onClick={(event) => {
                                    event.stopPropagation();
                                    window.open(`https://yandex.ru/maps/?whatshere[point]=${latlng.lng},${latlng.lat}&whatshere[zoom]=17`);
                                }}
                                sx={{
                                    minWidth: 'auto',
                                    px: { xs: 1, sm: 1.5 },
                                    py: { xs: 0.2, sm: 0.5 },
                                    fontSize: { xs: '0.7rem', sm: '0.75rem' }
                                }}
                            >
                                Карта
                            </Button>
                        )}
                    </Stack>
                </Paper>
            </Popup>,
            document.getElementsByClassName('leaflet-pane leaflet-popup-pane')[0]
        )
    )


}

export default PopupFider